export default "__VITE_ASSET__20127ce8__"